<template>
  <section class="bg">

    <Header page="respondents" title="👨 All Respondents 👩"/>

    <div v-if="!respondents" class="loading">
      <a-spin>
        <a-icon slot="indicator" type="loading" style="font-size: 40px; color: #1BD285;" spin />
      </a-spin>
    </div>

    <div class="card-container">

        <!-- Respondent Card -->

        <div v-for="respondent of respondents"  :key="respondent.id" class="respondent-card">

          <!-- Content for card -->
          <template v-if="respondent">

            <!-- Profile Pic -->
            <router-link v-if="respondent" :to="{ name: 'respondent', params: { uid: respondent.uid }}">
              <img :src="respondent.profile_pic">
            </router-link>

            <!-- Text Content -->
            <div>

              <!-- Respondent Name -->
              <router-link v-if="respondent" :to="{ name: 'respondent', params: { uid: respondent.uid }}">
                <p class="name">{{ respondent.uid }}</p>
              </router-link>

              <!-- Respondent Info -->
              <div class="demographics-container" v-if="respondent.age || respondent.gender || respondent.location">
                <img v-if="respondent.age" src="../assets/icons/user-icon.svg">
                <p>{{ respondent.age }}{{ respondent.age ? ',' : '' }} {{ respondent.gender ? respondent.gender.charAt(0).toUpperCase() : '' }}</p>
                <img v-if="respondent.location && respondent.location.city" src="../assets/icons/location-icon.svg">
                <p v-if="respondent.location && respondent.location.city">{{ respondent.location.city }}</p>
              </div>

              <!-- Answer Count -->
              <router-link v-if="respondent" :to="{ name: 'respondent', params: { uid: respondent.uid }}">
                <!-- <p v-if="respondent.answer_count" class="answer-count">{{ respondent.answer_count }} Answer{{ respondent.answer_count > 1 ? 's' : ''}}</p> -->
              </router-link>


            </div>
          </template>


          <!-- Empty / Loading State -->
          <img v-if="!respondent" src="../assets/respondent-loading.svg">

        </div>

    </div>


  </section>
</template>

<script>

import _ from 'lodash';
import moment from 'moment';
import Header from '@/components/Header.vue'

export default {
  name: 'respondent',
  components: {
    Header
  },
  data() {
    return {}
  },
  computed: {

    respondents() {

      // Get a list of all the answers for the survey...
      if (!this.$store.state.surveys) { return null }; // Still loading
      let survey_index = this.$route.params.survey_index;
      let survey = this.$store.state.surveys[survey_index];

      // Grab the respondents for this study from the store and return as an array.
      let survey_respondents = _.chain(this.$store.state.respondents).filter(respondent => respondent.started_studies && respondent.started_studies.includes(survey.id)).uniq().sortBy('name').compact().value();
      return survey_respondents;

      /*
      let answers = survey.answers;
      if (!answers) { return null }; // Still loading

      // Grab the respondents from the store and return as an array.
      let unique_respondent_ids = _.chain(answers).filter(answer => !answer.is_deleted).map('uid').uniq().compact().value();

      let respondents = _.chain(unique_respondent_ids).map(uid => {
        let respondent = this.$store.state.respondents[uid];
        if (!respondent) { return null };
        respondent.answer_count = _.filter(answers, ['uid', respondent.uid]).length;
        return respondent;
      }).sortBy('name').compact().value();

      return respondents;
      */

    }

  },
  methods: {},

  mounted() {

    let survey_index = this.$route.params.survey_index;

    // User has refreshed the page
    if (!this.$store.state.surveys) {
      this.$router.replace('/surveys'); // User hasn't authed yet, and therefore survey id hasn't been set - ideally I wait and showing loading instead of redirecting..
    };

  },

  created() {
    analytics.page('All Respondents');
  }

};
</script>

<style lang="scss" scoped>

section.bg{
  padding-bottom: 50px;
  background-image: linear-gradient(135deg, #eff0f3 1%,#fefeff 100%);
  min-height: 100%;
}

.card-container{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  width: 970px;
  margin: 0 auto;
  margin-top: 50px;
  font-family: "Montserrat", sans-serif;
}

.respondent-card{
  width: 300px;
  height: 110px;
  padding: 20px;
  padding-bottom: 25px;
  margin: 10px;
  margin-bottom: 20px;
  background-color: white;
  border: 1px solid #ECECEC;
  border-radius: 6px;
  box-shadow: 0 0 8px 0 rgba(0,0,0,.08);
  &>*{
    display: inline-block;
    vertical-align: top;
  }
  img{
    height: 70px;
    width: auto;
    max-width: 95px;
    border-radius: 4px;
    margin-right: 16px;
  }
  .name{
    font-size: 15px;
    font-weight: 600;
    color: rgb(30,30,30);
    margin-bottom: 6px;
    max-width: 193px;
    overflow: auto;
    text-overflow: ellipsis;
    opacity: .9;
    transition: all 0.3s ease;
    cursor: pointer;
    &:hover{
      opacity: 1;
    }
  }
  .demographics-container{
    height: 27px;
    & > *{
      display: inline-block;
    }
    img{
      object-fit: cover;
      width: 18px;
      height: 18px;
      margin-right: 2px;
      margin-top: -2px;
    }
    p{
      font-size: 12px;
      font-weight: 600;
      color: #0D303F;
      &:first-of-type{
        margin-right: 5px;
      }
      &:last-of-type{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 95px;
        margin-bottom: -5px;
      }
    }
  }
  .answer-count{
    font-size: 12px;
    font-weight: 600;
    color: #27AF7C;
    opacity: .95;
    transition: all 0.3s ease;
    margin-left: 3px;
    cursor: pointer;
    &:hover{
      opacity: 1;
    }
  }
}


.loading{
  height: 40px;
  width: 40px;
  margin: 0 auto;
  margin-top: 110px;
  display: block;
}


@media only screen
and (min-device-width : 320px)
and (max-device-width : 480px) {

.card-container{
  width: 100%;
  padding: 20px;
  margin-top: 35px;
}

.respondent-card{
  width: 48%;
  height: 100px;
  margin: 0px;
  margin-bottom: 15px;
  white-space: nowrap;
  img{
    height: 60px;
  }
  .name{
    max-width: 80px;
  }
}

}

/* Ipad Portrait */
@media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : portrait) {
  .card-container{
    width: 100%;
    padding: 40px;
    margin-top: 35px;
  }
  .respondent-card{
    width: 31%;
    height: 100px;
    margin: 0px;
    margin-bottom: 15px;
    white-space: nowrap;
    img{
      height: 60px;
    }
    .name{
      max-width: 80px;
    }
  }
}

</style>
